import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { greeting } from "@/lib/format";
import { ServiceCalendar, ServiceDetails } from "@/components/ServiceCalendar";
import { CalendarSync } from "@/components/CalendarSync";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CalendarDays, Repeat, ClipboardList, ArrowRight } from "lucide-react";

function StatTile({ icon: Icon, label, value, onClick, testid, accent }) {
  return (
    <Card
      onClick={onClick}
      data-testid={testid}
      className={`p-5 cursor-pointer hover:shadow-md transition-shadow border ${accent}`}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-red-100 dark:bg-red-900/40 flex items-center justify-center">
          <Icon className="w-5 h-5 text-red-700 dark:text-red-300" />
        </div>
        <div>
          <p className="text-2xl font-bold font-heading">{value}</p>
          <p className="text-xs text-muted-foreground">{label}</p>
        </div>
      </div>
    </Card>
  );
}

export default function VolunteerDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [shifts, setShifts] = useState([]);
  const [swaps, setSwaps] = useState([]);

  useEffect(() => {
    api.get("/planning/my-shifts").then((r) => setShifts(r.data)).catch(() => {});
    api.get("/swaps/mine").then((r) => setSwaps(r.data)).catch(() => {});
  }, []);

  const upcoming = shifts.filter((s) => new Date(`${s.service.date}T${s.service.end_time}`) >= new Date());
  const openSwaps = swaps.filter(
    (s) => s.to_user_id === user?.id && s.status === "requested"
  ).length;

  return (
    <div className="space-y-6" data-testid="volunteer-dashboard">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><h1 className="font-heading text-3xl font-extrabold tracking-tight">{greeting()}, {user?.name?.split(" ")[0]}</h1>
        <p className="text-muted-foreground mt-1">Hier is jouw overzicht.</p></div>
        <CalendarSync />
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatTile icon={ClipboardList} label="Geplande diensten" value={upcoming.length} testid="tile-shifts" onClick={() => navigate("/shifts")} accent="border-slate-200 dark:border-slate-800" />
        <StatTile icon={Repeat} label="Open ruilverzoeken" value={openSwaps} testid="tile-swaps" onClick={() => navigate("/swaps")} accent="border-slate-200 dark:border-slate-800" />
        <StatTile icon={CalendarDays} label="Beschikbaarheid" value="Invullen" testid="tile-availability" onClick={() => navigate("/availability")} accent="border-slate-200 dark:border-slate-800" />
        <StatTile icon={ArrowRight} label="Statistieken" value="Bekijk" testid="tile-stats" onClick={() => navigate("/stats")} accent="border-slate-200 dark:border-slate-800" />
      </div>

      <ServiceCalendar calendarId="volunteer-dashboard" services={shifts.map((a) => ({ ...a.service, id: a.id, assignment: a }))}
        getStatus={(entry) => ({ tone: "red", label: entry.assignment.service_type_name })}
        renderDetails={(entry) => <ServiceDetails service={entry}>
          <p className="text-sm text-red-700">{entry.assignment.service_type_name}</p>
          <Button variant="outline" size="sm" onClick={() => navigate(`/shifts?service=${entry.id}`)} data-testid={`dashboard-shift-details-${entry.id}`}>Naar mijn dienst</Button>
        </ServiceDetails>} />
    </div>
  );
}
